import React, { Fragment, useEffect, useMemo, useState } from 'react'

import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { v4 as uuid } from 'uuid'

import { Checkbox } from 'components/checkbox'
import Input from 'components/input'
import { isEmpty } from 'helpers/utils'
import NAMESPACES from 'localization/constants/namespaces'

import { PromoCodeContainer, PromoCodeLabel, InputLabel } from './styled'

const PromotionCode = ({
  handlePromoCodeCheckChange,
  handlePromoCodeChange,
  promoCode,
  errorPromoCode
}) => {
  const { t } = useTranslation(NAMESPACES.SEARCH_BOX)
  const [checked, toggleCheck] = useState(!isEmpty(promoCode))
  const promoCodeExpandedId = useMemo(() => uuid(), [])

  useEffect(() => {
    handlePromoCodeCheckChange && handlePromoCodeCheckChange(checked)
    if (promoCode && !checked) {
      toggleCheck(checked => !checked)
    }
  }, [checked, promoCode])

  return (
    <PromoCodeContainer>
      <Checkbox
        onChange={() => toggleCheck(checked => !checked)}
        checked={checked}
        text={t('shopping.search-box.promo-code.checkbox-label')}
        large
        ariaControls={promoCodeExpandedId}
      />
      {checked && (
        <Fragment>
          <PromoCodeLabel id={promoCodeExpandedId}>
            <InputLabel>{t('shopping.search-box.promo-code.input-label')}</InputLabel>
            <Input
              placeholder={t('shopping.search-box.promo-code.input-placeholder')}
              onChange={e => handlePromoCodeChange(e.target.value)}
              error={errorPromoCode}
              value={promoCode}
            />
          </PromoCodeLabel>
        </Fragment>
      )}
    </PromoCodeContainer>
  )
}

PromotionCode.propTypes = {
  handlePromoCodeCheckChange: PropTypes.func,
  promoCodeCheck: PropTypes.bool,
  handlePromoCodeChange: PropTypes.func,
  errorPromoCode: PropTypes.string
}

PromotionCode.defaultProps = {
  handlePromoCodeCheckChange: null,
  promoCodeCheck: false,
  handlePromoCodeChange: null,
  // onFocusPromoCode: null,
  errorPromoCode: ''
}

export default PromotionCode
